import { Component } from '@angular/core';
import { ToasterListComponent } from '@shared/components/toaster/components/toaster-list/toaster-list.component';

@Component({
  selector: 'toasters',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  imports: [ToasterListComponent],
})
export class ToasterComponent {}
